import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface UpdateCustomDevice {
  deviceTemplateId: string
  message: string
}

export interface UpdateFileInfoState {
  isLoading: boolean
  loadingError: string | null
  UpdateCustomDevice: UpdateCustomDevice | null
  httpStatus: number | null
}

export const initialState: UpdateFileInfoState = {
  isLoading: false,
  UpdateCustomDevice: null,
  loadingError: null,
  httpStatus: null
}

export const UpdateCustomDeviceInfoSlice = createSlice({
  name: 'updateCustomDeviceInfoSlice',
  initialState,
  reducers: {
    resetCustomDeviceUpload: () => {
      return {
        isLoading: false,
        UpdateCustomDevice: null,
        loadingError: null,
        httpStatus: null
      }
    },
    UpdateCustomDeviceFileInfoDataLoading: (state): UpdateFileInfoState => {
      return {
        isLoading: true,
        UpdateCustomDevice: null,
        loadingError: null,
        httpStatus: 0
      }
    },
    UpdateCustomDeviceFileInfoDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): UpdateFileInfoState => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        UpdateCustomDevice: null,
        httpStatus: action.payload.httpStatus
      }
    },
    UpdateCustomDeviceFileInfoData: (state, action: PayloadAction<{ data: UpdateCustomDevice, httpStatus: number }>): UpdateFileInfoState => {
      return {
        isLoading: false,
        loadingError: null,
        UpdateCustomDevice: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { UpdateCustomDeviceFileInfoDataLoading, UpdateCustomDeviceFileInfoDataError, UpdateCustomDeviceFileInfoData, resetCustomDeviceUpload } = UpdateCustomDeviceInfoSlice.actions
export default UpdateCustomDeviceInfoSlice.reducer
